import type {
  ModulationLocationContractPayload,
  ModulationLocationContractSchema,
  ModulationLocationContractsPathParams
} from '@libs/data-access/entities'

import { httpServices } from '../../../apis'
import type { QueryFnParams } from '../../../types'

export type FetchModulationLocationContractOptions = QueryFnParams<{
  pathParams: {
    modulation_location_contract_id?: number
  }
}>

/**
 * Fetch one modulation location contract
 */
export const fetchModulationLocationContract = async (
  opts: FetchModulationLocationContractOptions
) => {
  const response =
    await httpServices.core.get<ModulationLocationContractSchema>(
      `/modulation_location_contracts/${opts?.pathParams.modulation_location_contract_id}`
    )
  return response.data
}

export type FetchModulationLocationContractsOptions = QueryFnParams<{
  queryParams: {
    location_id?: number
  }
}>

/**
 * Fetch all modulation location contracts
 */
export const fetchModulationLocationContracts = async (
  opts: FetchModulationLocationContractsOptions
) => {
  const response = await httpServices.core.get<
    ModulationLocationContractSchema[]
  >(`/modulation_location_contracts`, {
    params: opts?.queryParams
  })
  return response.data
}

export type CreateModulationLocationContractOptions = QueryFnParams<{
  payload: ModulationLocationContractPayload
}>
/**
 * Create an operation for a given modulation user contract
 */
export const createModulationLocationContract = async (
  opts?: CreateModulationLocationContractOptions
) => {
  const response =
    await httpServices.core.post<ModulationLocationContractSchema>(
      `/modulation_location_contracts`,
      opts?.payload
    )
  return response.data
}

export type UpdateModulationLocationContractOptions = QueryFnParams<{
  payload: ModulationLocationContractPayload
  pathParams: ModulationLocationContractsPathParams
}>
/**
 * Update an operation for a given modulation user contract
 */
export const updateModulationLocationContract = async (
  opts?: UpdateModulationLocationContractOptions
) => {
  const response =
    await httpServices.core.put<ModulationLocationContractSchema>(
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      `/modulation_location_contracts/${opts.pathParams.modulation_location_contract_id}`,
      opts?.payload
    )
  return response.data
}

export type DeleteModulationLocationContractOptions = QueryFnParams<{
  pathParams: ModulationLocationContractsPathParams
  queryParams: { location_id: number }
}>
/**
 * Delete an operation for a given modulation user contract
 */
export const deleteModulationLocationContract = async (
  opts?: DeleteModulationLocationContractOptions
) => {
  const response = await httpServices.core.delete(
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    `/modulation_location_contracts/${opts.pathParams.modulation_location_contract_id}`
  )
  return response.data
}
